import { gql } from '@common/hooks';
import { CommentInfoFragment, CommentInfoFragmentType } from '@common/graphql';

export const StaffingRequestAssignmentWithCommentsFragment = gql`
  fragment StaffingRequestAssignmentFragment on StaffingRequestAssignment {
    id
    comments {
      ...CommentInfoFragment
    }
  }
  ${CommentInfoFragment}
`;

export type StaffingRequestAssignmentWithCommentsFragmentType = {
  id: string;
  comments: CommentInfoFragmentType[];
};
